import { isSet } from '../utils/isSet';

/**
 * Description: Contact Map Google Maps Setup
 * 
 * @class ContactMap
 * @typedef {ContactMap}
 */

class ContactMap {
    constructor (domNode, MapLib, MarkerLib, InfoWindowLib) {
        this.map;

        this.domNode = domNode;
        this.mapElm = this.domNode.querySelector("#map");
        this.zoomOutControlElm = this.domNode.querySelector(".map-controls__zoom-out");
        this.zoomInControlElm = this.domNode.querySelector(".map-controls__zoom-in");
        this.resetControlElm = this.domNode.querySelector(".map-controls__reset");

        //Google Map Libraries
        this.MapLib = MapLib;
        this.MarkerLib = MarkerLib;

        this.mapMarkers = [];
        this.locations = [];
        this.selectedSlug = '';
        this.zoom = 12;
        this.tilt = 30;
        this.lng = -3.981506;
        this.lat = 55.786059;

        this.iconBase = "../assets/img/svg/icons/";
        this.icons = {
            info: {
                icon: this.iconBase + "map-pin.svg",
            },
            current: {
                icon: this.iconBase + "map-pin--selected.svg",
            },
            user: {
                icon: this.iconBase + "map-pin--user.svg",
            }
        };

        const zoom = this.zoom;
        const tilt = this.tilt;
        const lat = this.lat;
        const lng = this.lng;
        this.map = new this.MapLib(this.mapElm, {
            center: {
                lat: lat,
                lng: lng
            },
            zoom: zoom,
            tilt: tilt,
            mapId: '1ae02ae600365ec8',
            streetViewControl: false,
            clickableIcons: false,
            mapTypeControl: false,
            fullscreenControl: false,
            disableDefaultUI: true,
            scrollwheel: false
        });

        this.zoomOutControlElm.addEventListener('click', this.handleMapZoomOut.bind(this), false);
        this.zoomInControlElm.addEventListener('click', this.handleMapZoomIn.bind(this), false);
        this.resetControlElm.addEventListener('click', this.handleMapReset.bind(this), false);
    }


    handleMapZoomIn(){
        const map = this.map;
        map.setZoom(map.getZoom() + 1);
    }

    handleMapZoomOut(){
        const map = this.map;
        map.setZoom(map.getZoom() - 1);
    }

    handleMapReset(){
        const position = new google.maps.LatLng(this.lat, this.lng);

        this.map.setZoom(this.zoom);
        this.map.setTilt(this.tilt);
        this.map.panTo(position);
    }
}

exports.ContactMap = ContactMap